import {
    SET_IS_MUTE // [UPDATE] Shutdown ack
} from '../constants/actions';

export const setIsMute = (isMute) => ({
    type: SET_IS_MUTE,
    isMute: isMute
});